
export const localeStorageKey = 'selectedLanguage';

export const getLocale = supportedLocales => {
  const defaultLang = 'en';
  const selectedLang = window.localStorage.getItem(localeStorageKey) || window?.navigator?.language;
  return selectedLang && supportedLocales.includes(selectedLang) ? selectedLang : defaultLang;
};

export const changeLocale = lang => {
  window.localStorage.setItem(localeStorageKey, lang);
  window.location.reload();
};
